// Native circular overview, not a dewarped perspective view. `pano: 360`
// describes azimuthal coverage; the optical diameter is about 180 degrees.
// No library record currently supplies calibrated distortion or image-circle
// coordinates, so use an explicitly estimated centred equidistant lens.
export function fisheyeProjection(g) {
  if (g?.m?.type !== 'fisheye' || !g.m.pano || g.profileId) return null;
  const angles = [g.m.publishedHfov, g.m.publishedVfov].filter(a => Number.isFinite(a) && a >= 160 && a <= 220);
  const diameter = angles.length ? Math.min(...angles) : 180;
  const cropped=g.m.pano<360 && g.m.publishedHfov>=160 && g.m.publishedHfov<=220 && g.m.publishedVfov>0 && g.m.publishedVfov<160;
  const lensDiameter=cropped?g.m.publishedHfov:diameter;
  const scale=cropped?[1,g.m.publishedVfov/lensDiameter]:[Math.max(1,g.outputAspect),Math.max(1,1/g.outputAspect)];
  return { kind: 'fisheye', diameter:lensDiameter, halfAngle: lensDiameter * Math.PI / 360, scale, cropped,
    hfov:cropped?g.m.publishedHfov:diameter,vfov:cropped?g.m.publishedVfov:diameter,
    aspect: g.outputAspect, estimatedAngle: !angles.length,
    note: `Native fisheye · estimated equidistant projection. ${cropped?`Published ${g.m.publishedHfov}° × ${g.m.publishedVfov}° cropped wall view`:`${angles.length ? 'Published' : 'Assumed'} ${diameter}° lens diameter`}; image-circle crop and distortion are uncalibrated. No dewarping applied.` };
}

/** Camera-local ray, with -Z forward and +Y up. UV has its origin at bottom left. */
export function fisheyeRay(u, v, projection) {
  const { scale, halfAngle } = projection;
  const x = (2*u-1)*scale[0], y = (2*v-1)*scale[1], r = Math.hypot(x,y);
  if (r > 1) return null;
  const theta = r*halfAngle, radial = r > 1e-9 ? Math.sin(theta)/r : halfAngle;
  return { x:x*radial, y:y*radial, z:-Math.cos(theta) };
}

// Shared with the ray tracer so raster, reconstruction guides and traced rays
// agree at every pixel. w enables projection; xyz are half-angle and image scale.
export const fisheyeRayGLSL = `
uniform vec4 slFisheye;
vec2 slFisheyePosition(vec2 uv) {
  return (2. * uv - 1.) * slFisheye.yz;
}
vec3 slFisheyeRay(vec2 uv) {
  vec2 p = slFisheyePosition(uv); float r = length(p), theta = r * slFisheye.x;
  return vec3(p * (r > .000001 ? sin(theta)/r : slFisheye.x), -cos(theta));
}`;
